import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogContent, Typography, Divider, DialogActions, Grid, DialogTitle, Box } from "@material-ui/core";
import DataService from "../../../../Service";

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
    },
    title: {
        textTransform: "capitalize",
    },
    dialog_title: {
        "& h6": {
            fontWeight: "700"
        }
    }
}));

interface ICurrentSelection {
    assignment_id: number;
    session_scenario_id: number;
    title: string;
}

interface IProps {
    isOpen: any,
    onClose(): void,
    currentSelection?: ICurrentSelection,
}

const MIFeedbackModal = (props: IProps) => {
    const { isOpen, onClose, currentSelection } = props;
    const classes = useStyles();
    const [feedbackData, setFeedbackData] = useState([]);

    useEffect(() => {
        DataService.getData(currentSelection, "feedback_listing").then((res: any) => {
            if (res?.success) {
                setFeedbackData(res?.collate_feedbacks);
            }
        }).catch((error: any) => {
            setFeedbackData([]);
        })
    }, [currentSelection])

    return (
        <>
            <Dialog maxWidth={"md"} fullWidth={true} open={isOpen} onClose={() => onClose()}
                aria-labelledby="base-station-manage">
                <DialogTitle id="customized-dialog-title" className={classes.dialog_title}>
                    {currentSelection?.title || ''}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid item xs={12}>
                        <Grid container direction="row" alignItems="center" style={{ marginTop: 10, borderWidth: 1, borderColor: "#ddd", borderStyle: "solid", padding: 16 }}>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">
                                    <Box fontWeight="fontWeightBold">Feedback</Box>
                                </Typography>
                            </Grid>
                        </Grid></Grid>
                    {
                        feedbackData?.length ?
                            feedbackData?.map((option: any) => {
                                return <>
                                    <Grid container direction="row" alignItems="center" style={{ borderWidth: 1, borderColor: "#ddd", borderStyle: "solid", padding: "5px 16px" }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h2" style={{ color: "#320032" }}>
                                                <Box >{option?.feedback || "-"}</Box>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                </>
                            }) : <Grid container direction="row" alignItems="center" style={{ borderWidth: 1, borderColor: "#ddd", borderStyle: "solid", padding: "5px 16px" }}>
                                <Grid item xs={3}>
                                    <Typography variant="h2" style={{ color: "#232323" }}>
                                        <Box >{'Record not found'}</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => onClose()}
                        disableElevation type="button"
                        style={{ textTransform: 'capitalize' }}
                        variant={"contained"}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default MIFeedbackModal;
